import { CdkDragDrop } from "@angular/cdk/drag-drop";
import { Component, Input, OnChanges, OnInit } from "@angular/core";
import {
  ControlContainer,
  UntypedFormArray,
  UntypedFormBuilder,
  UntypedFormControl,
  UntypedFormGroup,
  FormGroupDirective,
} from "@angular/forms";
import { MatDialog } from "@angular/material/dialog";
import { ConfirmationDialogComponent } from "@dialogs/confirmation/confirmation.component";
import {
  faSortAmountDown,
  faSortAmountUp,
  faExclamationTriangle,
  faArrowDownAZ,
  faArrowUpZA,
} from "@fortawesome/pro-light-svg-icons";
import { faPlus } from "@fortawesome/pro-regular-svg-icons";
import { faTrash } from "@fortawesome/pro-solid-svg-icons";
import { CanvasService } from "@services/canvas.service";
import { CommonService } from "@services/common.service";
import { moveItemInFormArray } from "../../../../shared/move-item-in-form-array";
import { faGripDotsVertical } from "@fortawesome/pro-regular-svg-icons";
@Component({
    selector: "app-sorting",
    templateUrl: "./sorting.component.html",
    styleUrls: ["./sorting.component.scss"],
    viewProviders: [
        { provide: ControlContainer, useExisting: FormGroupDirective },
    ],
    standalone: false
})
export class SortingComponent implements OnInit, OnChanges {
  @Input() currentDataFields!: any;
  @Input() sortFields!: any;
  @Input() canvasOptions!: any;

  childForm: any;
  faPlus = faPlus;
  faTrash = faTrash;
  faSortAmountUp = faSortAmountUp;
  faSortAmountDown = faSortAmountDown;
  faExclamationTriangle = faExclamationTriangle;
  faArrowDownAZ = faArrowDownAZ;
  faArrowUpZA = faArrowUpZA;
  faGripDotsVertical = faGripDotsVertical;

  public fieldForm!: UntypedFormGroup;
  public aggregateData: any = [];
  public ascending: any;
  public decending: any;
  public sortId: any;
  public sortOptions: any = [];
  public filteredDataFields: any = [];

  constructor(
    public parentF: FormGroupDirective,
    private fb: UntypedFormBuilder,
    public commonService: CommonService,
    private canvasService: CanvasService,
    public dialog: MatDialog
  ) {}

  createItem(dataPointId: any, sort: any): UntypedFormGroup {
    if (dataPointId) {
      return this.fb.group({
        field: new UntypedFormControl(dataPointId),
        sort: new UntypedFormControl(sort),
      });
    } else {
      return this.fb.group({
        field: new UntypedFormControl(),
        sort: new UntypedFormControl(this.ascending),
      });
    }
  }

  choosePlaceholder() {
    let placeholder = "Choose Sort to add";
    if (this.currentDataFields.length == this.sortlist.value.length)
      placeholder = "All Available Fields Added";
    return placeholder;
  }
  disableSelect() {
    if (this.fieldForm)
      if (
        this.currentDataFields &&
        this.sortlist &&
        this.currentDataFields.length == this.sortlist.value.length
      )
        this.fieldForm.get("selectItem")?.disable();
      else this.fieldForm.get("selectItem")?.enable();
  }
  addItem(dataPointId?: any, sort?: any): void {
    let sortfield = this.fieldForm.get("sortby") as UntypedFormArray;
    sortfield.push(this.createItem(dataPointId, sort));
  }
  deleteItem(idx: number) {
    let sortfield = this.fieldForm.get("sortby") as UntypedFormArray;
    sortfield.removeAt(idx);
    this.buildAggregateData();
  }
  removeDataField(event: any, index: number) {
    event.stopPropagation();

    const elem = "sort-" + index;
    const element = document.getElementById(elem);
    const rect = element
      ? element.getBoundingClientRect()
      : { top: 0, left: 0 };

    const dialogRef = this.dialog.open(ConfirmationDialogComponent, {
      disableClose: true,
      data: {
        message: "Remove this sort field?",
        actionButton: "remove",
      },
      panelClass: ["canvas-dialog", "dialog-right"],
      position: { top: rect.top - 50 + "px", left: rect.left - 310 + "px" },
    });

    dialogRef.afterClosed().subscribe((result) => {
      if (result) {
        this.deleteItem(index);
        this.buildAggregateData();
      }
    });
  }
  get sortlist(): any {
    if (this.fieldForm) return this.fieldForm.get("sortby") as UntypedFormArray;
  }

  changeSortDirection(id: any, direction: any) {
    let sortfield = this.fieldForm.get("sortby") as UntypedFormArray;
    sortfield.at(id).get("sort")!.setValue(direction);
    let dataPointId = sortfield.at(id).get("field")!.value;
    if (dataPointId) this.buildAggregateData();
  }
  getName(id: any) {
    let name = "";

    let sortfield = this.fieldForm.get("sortby") as UntypedFormArray;
    let dataPointId = sortfield.at(id).get("field")!.value;

    const datapoint = this.currentDataFields.filter((item: any) => {
      return item.id == dataPointId;
    });
    name = datapoint[0].name;
    return name;
  }
  addSort() {
    let selected = this.fieldForm.get("selectItem")!.value;

    if (selected) {
      this.addItem(selected, this.sortOptions.data[0].options.data[0].value);

      setTimeout(() => {
        this.buildAggregateData();
        this.fieldForm.get("selectItem")!.setValue("");
      }, 100);
    }
  }
  buildAggregateData() {
    let sortfield = this.fieldForm.get("sortby") as UntypedFormArray;
    this.aggregateData = this.commonService.generateSorts(
      this.sortId,
      sortfield,
      null
    );
    this.childForm.get("sortdata")!.setValue(this.aggregateData);
    // make refresh call and emit the chart data to the parent
    this.canvasService.refreshCanvas(this.childForm).subscribe(
      (success: any) => {
        this.canvasService.triggerEnable();
        const data = success.data;
        this.canvasService.pushChartToStorage(data);
        this.canvasService.populateCanvas(data);
        this.disableSelect();
      },
      (error: any) => {
        this.canvasService.triggerEnable();
        const data = this.canvasService.getChartFromStorage();
        this.canvasService.populateCanvas(data);
      }
    );
  }

  drop(event: CdkDragDrop<string[]>) {
    if (event.previousIndex != event.currentIndex) {
      moveItemInFormArray(
        this.sortlist,
        event.previousIndex,
        event.currentIndex
      );
      this.buildAggregateData();
    }
  }

  isInSorts(id: any): any {
    let found = false;
    const field = this.sortlist.value.find((x: any) => x.field === id);
    if (field) found = true;
    return found;
  }

  initForm() {
    this.fieldForm = this.fb.group({
      selectItem: new UntypedFormControl(""),
      sortby: this.fb.array([]),
    });
  }
  ngOnChanges() {
    if (this.fieldForm) {
      let fieldsFormArray = this.fieldForm.get("sortby") as UntypedFormArray;
      fieldsFormArray.clear();
      if (this.sortOptions.data && this.sortOptions.data.length > 0) {
        this.ascending = this.sortOptions.data[0].options.data[0].value;
        this.decending = this.sortOptions.data[0].options.data[1].value;

        this.sortId = this.sortOptions.data[0].id;
        if (this.sortFields) {
          this.sortFields.forEach((element: any) => {
            if (element.fields) {
              this.addItem(
                element.fields.data[0].dataPoint.data.id,
                element.fields.data[0].value
              );
            }
          });
        }
      }
    }
    this.disableSelect();
  }
  ngOnInit(): void {
    this.childForm = this.parentF.form;
    this.initForm();
    if (this.canvasOptions && this.canvasOptions.sortOptions) {
      this.sortOptions = this.canvasOptions.sortOptions;
    }
    let fieldsFormArray = this.fieldForm.get("sortby") as UntypedFormArray;
    fieldsFormArray.clear();

    if (this.sortOptions.data && this.sortOptions.data.length > 0) {
      this.ascending = this.sortOptions.data[0].options.data[0].value;
      this.decending = this.sortOptions.data[0].options.data[1].value;

      this.sortId = this.sortOptions.data[0].id;
      if (this.sortFields) {
        this.sortFields.forEach((element: any) => {
          if (element.fields) {
            this.addItem(
              element.fields.data[0].dataPoint.data.id,
              element.fields.data[0].value
            );
          }
        });
      }
    }
    this.disableSelect();
  }
}
